module.exports = __webpack_public_path__ + "img/chara_1.2563669d.png";